import { useMutation, useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

import { UNLINK_ACCOUNT } from "../../GraphQL/mutations/connectAccounts";
import { TSubscriptionStatus } from "./Subscriptions/types";
import { UPDATE_RIOT_REGION } from "../../GraphQL/riotRSO";
import {
  GET_USER_PARTNER_SETTINGS,
  UPDATE_USER_PARTNER_SETTINGS,
} from "MVVM/GraphQL/thirdPartySettings";
import { Entries } from "MVVM/Views/ProfileSettings/ThirdPartySettings/types";

export const LinkedAccountsViewModel = () => {
  const [unlinkAccount] = useMutation(UNLINK_ACCOUNT);
  const [updateRiotRegion] = useMutation(UPDATE_RIOT_REGION, {
    onError: () => {},
  });
  return { updateRiotRegion, unlinkAccount };
};

export const SubscriptionViewModel = () => {
  const { loading, data, error } = useQuery(
    gql`
      query SubscriptionStatus {
        subscriptionStatus {
          success
          subscription {
            provider
            isPaid
            userGroup
            isRenewing
            isUpgraded
            chargeAmount
            timePeriod
            isAdmin
            isExpiring
            hasSubscription
            expires
            dateNextCharge
          }
        }
      }
    `,
    {
      fetchPolicy: "network-only",
    },
  );

  return {
    error,
    loading,
    data: data as {
      subscriptionStatus: { subscription: TSubscriptionStatus };
    },
  };
};

export const ThirdPartySettingsViewModel = () => {
  const { loading, data, error } = useQuery(GET_USER_PARTNER_SETTINGS, {
    fetchPolicy: "network-only",
  });

  const [updateUserPartnerSettings, { loading: updating, error: updateError }] =
    useMutation(UPDATE_USER_PARTNER_SETTINGS);

  return {
    error,
    loading,
    data: data as {
      userPartnerSettings: { entries: Entries; success: boolean };
    },
    updateUserPartnerSettings,
    updateError,
    updating,
  };
};
